import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
const reasons = [{
  title: 'We come to you',
  text: "Your home, office, or anywhere that's convenient — no drop-off required. We bring our own water and detailing equipment. We require access to a standard electrical outlet at the service location."
}, {
  title: 'Owner-operated by Mike',
  text: 'Every vehicle receives personal, hands-on attention from the owner, not a rotating crew.'
}, {
  title: 'Premium, eco-friendly products',
  text: 'Professional-grade products and equipment for showroom-quality results, from seat shampooing to clay bar and hybrid ceramic protection.'
}, {
  title: 'Rated 5 stars on Google and Yelp',
  text: 'A loyal customer base across Ventura County, earned through honest pricing, reliable scheduling, and results that speak for themselves.'
}];
interface WhyChooseUsProps {
  showAboutLink?: boolean;
}
export function WhyChooseUs({
  showAboutLink = true
}: WhyChooseUsProps) {
  return <section className="w-full bg-black py-16 px-4 border-t border-zinc-900" aria-labelledby="why-heading" data-id="element-584" data-mp="1ndlnc4njo2q1">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-[1fr_1.4fr] gap-10 lg:gap-16" data-id="element-585" data-mp="1iesj72u5do2j">
        <div data-id="element-586" data-mp="1x3585futi6nj">
          <h2 id="why-heading" className="text-3xl sm:text-4xl md:text-5xl font-black uppercase leading-tight" data-id="element-587" data-mp="1x3opovgk2t11">
            <span className="text-white" data-id="element-588" data-mp="1s7geft5hbjz5">Why Choose</span>{' '}
            <span className="text-yellow-400" style={{
            color: "#FFE81A"
          }} data-id="element-589" data-mp="14gu9wbuoohtw">Mike's Pro Detail</span>
          </h2>
          <div className="mt-5 h-1 w-24 bg-red-600 rounded-full shadow-[0_0_10px_rgba(220,38,38,0.8)]" data-id="element-590" data-mp="zi95e08efbzn" />
          <p className="mt-6 text-lg text-gray-300 leading-relaxed" data-id="element-591" data-mp="1efjnhsfjrg4c">
            A premium, fully mobile auto detailing service — we treat every
            vehicle like it's our own. Now serving homes and offices across
            Ventura County, including{' '}
            <Link to="/mobile-detailing-thousand-oaks" className="text-white font-bold underline underline-offset-4 decoration-red-600 hover:decoration-white transition-colors duration-150" data-id="element-592" data-mp="2kuu2f1r79574">
              mobile detailing in Thousand Oaks
            </Link>
            .
          </p>
          {showAboutLink && <Link to="/about" className="mt-6 inline-flex items-center gap-2 text-yellow-400 font-black uppercase tracking-wider hover:text-yellow-300 transition-colors duration-150" style={{
          color: "#FFE81A"
        }} data-id="element-593" data-mp="31v58jururoye">
              About Mike's Pro Detail
              <ArrowRight className="w-4 h-4" aria-hidden="true" data-id="element-594" data-mp="294wpm0pht0ir" />
            </Link>}
        </div>

        <dl className="divide-y divide-zinc-800 border-y border-zinc-800" data-id="element-595" data-mp="2e3hs66s7vwad">
          {reasons.map(reason => <div key={reason.title} className="py-5" data-id="element-596" data-mp="2j32qqg3h62mk">
              <dt className="text-lg sm:text-xl font-black uppercase text-white" data-id="element-597" data-mp="2nwp3s9djw8iw">
                {reason.title}
              </dt>
              <dd className="mt-2 text-gray-400 leading-relaxed" data-id="element-598" data-mp="1qe5lbdkd40b8">{reason.text}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}